import { z } from 'zod';
export const publicProfileSchema = z.object({
    slug: z.string(),
    displayName: z.string(),
    bio: z.string().nullable(),
    avatarUrl: z.string().nullable(),
});
export const markSeenSchema = z.object({
    wishIds: z.array(z.string().cuid2().or(z.string())).min(1).max(500),
});
//# sourceMappingURL=public.schema.js.map